// src/pages/admin/UploadAnnouncement.js
import React, { useState } from "react";
import { API_BASE, fileHref } from "../../services/apiClient";
import { formatDate, formatDateTime } from "../../utils/dateFormat";
import { useAnnouncements } from "../../context/AnnouncementContext";
import { PageNav, PageSummary, usePaging } from "../../components/admin/Pager";

// today in Thailand (yyyy-mm-dd) — the heading promises the image counts as today's announcement
const todayBangkok = () => new Date(Date.now() + 7 * 3600e3).toISOString().slice(0, 10);

function UploadAnnouncement() {
  const [status, setStatus] = useState("");
  const [preview, setPreview] = useState(null);
  // pictures uploaded so far, newest first (owner 28-10-2569: rows per page on every admin list)
  const { announcements, reloadAnnouncements } = useAnnouncements();
  const pictures = announcements
    .filter((a) => /\.(png|jpe?g)($|\?)/i.test(a.imageUrl || a.fileUrl || ""))
    .sort((a, b) => String(b.createdAt || b.uploadedAt || "").localeCompare(String(a.createdAt || a.uploadedAt || "")));
  const paging = usePaging(pictures, "mng_uploads_page_size", "");

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!/\.(png|jpe?g)$/i.test(file.name)) {
      setStatus("รองรับเฉพาะรูป PNG / JPG");
      return;
    }
    setPreview(URL.createObjectURL(file));

    const issueDate = todayBangkok();
    const formData = new FormData();
    formData.append("image", file);
    formData.append("issueDate", issueDate);

    try {
      setStatus("กำลังอัปโหลด...");
      const res = await fetch(`${API_BASE}/api/announcement/upload`, {
        method: "POST",
        body: formData,
      });

      const data = await res.json().catch(() => ({}));
      if (res.ok && data.success) {
        reloadAnnouncements();
        setStatus(`อัปโหลดสำเร็จ · ลงวันที่ ${formatDate(issueDate)} · ดูได้ที่ "รายการประกาศ"`);
      } else {
        setStatus(`อัปโหลดไม่สำเร็จ: ${data.message || `HTTP ${res.status}`}`);
      }
    } catch (err) {
      console.error(err);
      setStatus("เชื่อมต่อ server ไม่ได้");
    } finally {
      e.target.value = "";
    }
  };

  return (
    <div style={{ maxWidth: 600, margin: "0 auto", padding: 16 }}>
      <h2>อัปโหลดรูปใบประกาศ (นับเป็นประกาศของวันนี้)</h2>

      <input type="file" accept=".png,.jpg,.jpeg,image/png,image/jpeg" onChange={handleFileChange} />

      {preview && (
        <div style={{ marginTop: 10 }}>
          <p>ตัวอย่างรูป:</p>
          <img
            src={preview}
            alt="preview"
            style={{ width: 200, border: "1px solid #ccc" }}
          />
        </div>
      )}

      {status && <p style={{ marginTop: 10 }}>{status}</p>}

      <h3 style={{ marginTop: 28 }}>รูปประกาศที่อัปโหลดล่าสุด</h3>
      {pictures.length === 0 ? (
        <p className="adm-note">ยังไม่มีรูปประกาศ</p>
      ) : (
        <>
          <PageSummary paging={paging} unit="รูป" />
          <ul className="upl-list">
            {paging.shown.map((a) => (
              <li key={a.id}>
                <img src={fileHref(a.imageUrl || a.fileUrl)} alt="" loading="lazy" />
                <span>
                  ลงวันที่ {formatDate(a.issueDate) || "-"}
                  <small>อัปโหลด {formatDateTime(a.createdAt || a.uploadedAt) || "-"} · {a.title || "-"}</small>
                </span>
                <a href={fileHref(a.imageUrl || a.fileUrl)} target="_blank" rel="noreferrer">เปิด ↗</a>
              </li>
            ))}
          </ul>
          <PageNav paging={paging} />
        </>
      )}
    </div>
  );
}

export default UploadAnnouncement;
